"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SOCIAL_MEDIA_SITES = exports.PAID_SEARCHES = exports.PAID_SOCIAL = exports.OTHER_CAMPAIGNS = exports.SEARCH_ENGINES = void 0;
exports.SEARCH_ENGINES = [
    'bing',
    'google',
    'yahoo',
    'baidu',
    'yandex',
    'ask',
];
exports.OTHER_CAMPAIGNS = ['email', 'adword', 'ppc', 'cpc'];
exports.PAID_SOCIAL = ['paid', 'ppc', 'cpc'];
exports.PAID_SEARCHES = ['adword', 'ppc', 'cpc'];
exports.SOCIAL_MEDIA_SITES = [
    'blogcatalog',
    'cotweet',
    'delicious',
    'digg',
    'facebook',
    'fb',
    'fark',
    'flickr',
    'friendfeed',
    'google+',
    'hackernews',
    'hootsuite',
    'instagram',
    'ig',
    'knol',
    'linkedin',
    'links.hubspot.com',
    'livejournal',
    'meebo',
    'metacafe',
    'mixx',
    'mybloglog',
    'myspace',
    'ning',
    'orkut',
    'pinterest',
    'plurk',
    'propeller',
    'quora',
    'qq',
    'xw',
    'mp',
    'mail',
    'reddit',
    'seesmic',
    'slashdot',
    'slide',
    'slideshare',
    'snapchat',
    'sphinn',
    'stumbleupon',
    'squidoo',
    'technorati',
    'tiktok',
    "tip'd",
    'triiibes',
    'tumblr',
    'twitch',
    'twitter',
    'vimeo',
    'whatsapp',
    'wikipedia',
    'xing',
    'youtube',
    'zhihu',
];
//# sourceMappingURL=constants.js.map